import type { Crumb } from "./layout";

/** Structured data names the production origin: a staging copy must not claim other URLs. */
const ORIGIN = "https://listou.fr";

export const faqJsonLd = (items: { question: string; answer: string }[]) => ({
  "@type": "FAQPage",
  mainEntity: items.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: { "@type": "Answer", text: item.answer },
  })),
});

export const breadcrumbJsonLd = (items: Crumb[], currentPath: string) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.label,
    item: ORIGIN + (item.to ?? currentPath),
  })),
});

export const rankingJsonLd = (name: string, entries: { name: string; slug: string }[]) => ({
  "@type": "ItemList",
  name,
  itemListOrder: "https://schema.org/ItemListOrderAscending",
  numberOfItems: entries.length,
  itemListElement: entries.map((entry, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: entry.name,
    url: `${ORIGIN}/prenoms/${entry.slug}`,
  })),
});

export const datasetJsonLd = (fields: {
  name: string;
  description: string;
  coverage: string;
  spatial?: string;
}) => ({
  "@type": "Dataset",
  name: fields.name,
  description: fields.description,
  temporalCoverage: fields.coverage,
  spatialCoverage: fields.spatial ?? "France",
  isBasedOn: "https://www.insee.fr/fr/statistiques/8595130",
  license: "https://www.etalab.gouv.fr/licence-ouverte-open-licence/",
  creator: { "@type": "Organization", name: "Insee", url: "https://www.insee.fr" },
});

/** One script carrying several entities, as `seo()` takes a single JSON-LD document. */
export const graph = (...entities: Record<string, unknown>[]) => ({
  "@context": "https://schema.org",
  "@graph": entities,
});
